import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_7951c8ba from 'nuxt_plugin_plugin_7951c8ba' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_b85caad8 from 'nuxt_plugin_sentryserver_b85caad8' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_3e18390c from 'nuxt_plugin_sentryclient_3e18390c' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_3d46c574 from 'nuxt_plugin_plugin_3d46c574' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_index_052ab284 from 'nuxt_plugin_index_052ab284' // Source: ./firebase/index.js (mode: 'all')
import nuxt_plugin_serviceauthinitialize_006a2d13 from 'nuxt_plugin_serviceauthinitialize_006a2d13' // Source: ./firebase/service.auth.initialize.js (mode: 'all')
import nuxt_plugin_nuxtleaflet_7d210bf5 from 'nuxt_plugin_nuxtleaflet_7d210bf5' // Source: ./nuxt-leaflet.js (mode: 'client')
import nuxt_plugin_pluginutils_3a59ad6b from 'nuxt_plugin_pluginutils_3a59ad6b' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_7eb6e814 from 'nuxt_plugin_pluginrouting_7eb6e814' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_93ba598e from 'nuxt_plugin_pluginmain_93ba598e' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_101fbad0 from 'nuxt_plugin_axios_101fbad0' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_nuxtzendesk_aad15c54 from 'nuxt_plugin_nuxtzendesk_aad15c54' // Source: ./nuxt-zendesk.js (mode: 'client')
import nuxt_plugin_plugin_3f29c4b2 from 'nuxt_plugin_plugin_3f29c4b2' // Source: ./nuxt-highcharts/plugin.js (mode: 'all')
import nuxt_plugin_gtm_711e14b4 from 'nuxt_plugin_gtm_711e14b4' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_moment_028330c8 from 'nuxt_plugin_moment_028330c8' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_image_09b2906a from 'nuxt_plugin_image_09b2906a' // Source: ./image.js (mode: 'all')
import nuxt_plugin_workbox_08ecbbec from 'nuxt_plugin_workbox_08ecbbec' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_6b1d5202 from 'nuxt_plugin_metaplugin_6b1d5202' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_61ce071a from 'nuxt_plugin_iconplugin_61ce071a' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_services_412d2f9b from 'nuxt_plugin_services_412d2f9b' // Source: ../../../plugins/services.ts (mode: 'all')
import nuxt_plugin_axios_397e54eb from 'nuxt_plugin_axios_397e54eb' // Source: ../../../plugins/axios.ts (mode: 'all')
import nuxt_plugin_i18n_66ff13db from 'nuxt_plugin_i18n_66ff13db' // Source: ../../../plugins/i18n.ts (mode: 'all')
import nuxt_plugin_posthog_db8fbc04 from 'nuxt_plugin_posthog_db8fbc04' // Source: ../../../plugins/post-hog.js (mode: 'client')
import nuxt_plugin_googlemap_2ec973be from 'nuxt_plugin_googlemap_2ec973be' // Source: ../../../plugins/google-map (mode: 'client')
import nuxt_plugin_vuexpersist_25bdab30 from 'nuxt_plugin_vuexpersist_25bdab30' // Source: ../../../plugins/vuex-persist.js (mode: 'client')
import nuxt_plugin_chart_48b5b2cf from 'nuxt_plugin_chart_48b5b2cf' // Source: ../../../plugins/chart.js (mode: 'client')
import nuxt_plugin_checkVersion_67b53047 from 'nuxt_plugin_checkVersion_67b53047' // Source: ../../../plugins/checkVersion.ts (mode: 'client')
import nuxt_plugin_vue2editor_60d31c90 from 'nuxt_plugin_vue2editor_60d31c90' // Source: ../../../plugins/vue2-editor (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s","title":"IREEN","htmlAttrs":{"lang":"de"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0,minimum-scale=1.0, user-scalable=no"},{"name":"format-detection","content":"telephone=no"},{"name":"application-name","content":"IREEN"},{"name":"theme-color","content":"#0fdb7e"},{"name":"apple-mobile-web-app-title","content":"IREEN"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black"},{"property":"og:type","content":"website"},{"property":"og:image","content":"https:\u002F\u002Ffirebasestorage.googleapis.com\u002Fv0\u002Fb\u002Fsummer-ranger-286213.appspot.com\u002Fo\u002Fglobal-assets%2Fogimg.jpg?alt=media&token=c1f7c401-6c12-4670-9770-a42f800e1b44"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Sans+Display:wght@200;300;400;500;600;700;800;900&family=Sora:wght@200;300;400;500;600;700;800&display=swap","rel":"stylesheet"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"script":[{"id":"usercentrics-cmp","src":"https:\u002F\u002Fapp.usercentrics.eu\u002Fbrowser-ui\u002Flatest\u002Floader.js","data-settings-id":"GHH639gOG","data-version":"preview","async":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-NDBBFQN')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-NDBBFQN&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7951c8ba === 'function') {
    await nuxt_plugin_plugin_7951c8ba(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_b85caad8 === 'function') {
    await nuxt_plugin_sentryserver_b85caad8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_3e18390c === 'function') {
    await nuxt_plugin_sentryclient_3e18390c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_3d46c574 === 'function') {
    await nuxt_plugin_plugin_3d46c574(app.context, inject)
  }

  if (typeof nuxt_plugin_index_052ab284 === 'function') {
    await nuxt_plugin_index_052ab284(app.context, inject)
  }

  if (typeof nuxt_plugin_serviceauthinitialize_006a2d13 === 'function') {
    await nuxt_plugin_serviceauthinitialize_006a2d13(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtleaflet_7d210bf5 === 'function') {
    await nuxt_plugin_nuxtleaflet_7d210bf5(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_3a59ad6b === 'function') {
    await nuxt_plugin_pluginutils_3a59ad6b(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_7eb6e814 === 'function') {
    await nuxt_plugin_pluginrouting_7eb6e814(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_93ba598e === 'function') {
    await nuxt_plugin_pluginmain_93ba598e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_101fbad0 === 'function') {
    await nuxt_plugin_axios_101fbad0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtzendesk_aad15c54 === 'function') {
    await nuxt_plugin_nuxtzendesk_aad15c54(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_3f29c4b2 === 'function') {
    await nuxt_plugin_plugin_3f29c4b2(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_711e14b4 === 'function') {
    await nuxt_plugin_gtm_711e14b4(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_028330c8 === 'function') {
    await nuxt_plugin_moment_028330c8(app.context, inject)
  }

  if (typeof nuxt_plugin_image_09b2906a === 'function') {
    await nuxt_plugin_image_09b2906a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_08ecbbec === 'function') {
    await nuxt_plugin_workbox_08ecbbec(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_6b1d5202 === 'function') {
    await nuxt_plugin_metaplugin_6b1d5202(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_61ce071a === 'function') {
    await nuxt_plugin_iconplugin_61ce071a(app.context, inject)
  }

  if (typeof nuxt_plugin_services_412d2f9b === 'function') {
    await nuxt_plugin_services_412d2f9b(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_397e54eb === 'function') {
    await nuxt_plugin_axios_397e54eb(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_66ff13db === 'function') {
    await nuxt_plugin_i18n_66ff13db(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_posthog_db8fbc04 === 'function') {
    await nuxt_plugin_posthog_db8fbc04(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlemap_2ec973be === 'function') {
    await nuxt_plugin_googlemap_2ec973be(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_25bdab30 === 'function') {
    await nuxt_plugin_vuexpersist_25bdab30(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chart_48b5b2cf === 'function') {
    await nuxt_plugin_chart_48b5b2cf(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_checkVersion_67b53047 === 'function') {
    await nuxt_plugin_checkVersion_67b53047(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2editor_60d31c90 === 'function') {
    await nuxt_plugin_vue2editor_60d31c90(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
